import { Box, Button, Grid2 as Grid } from "@mui/material";

interface TemplateFormActionsProps {
  isSaving: boolean;
  onSave: () => void;
  onCancel: () => void;
}

const TemplateFormActions = ({
  isSaving,
  onSave,
  onCancel,
}: TemplateFormActionsProps) => {
  return (
    <Grid size={12}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 1.5,
          mt: 2,
        }}
      >
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onSave}
          disabled={isSaving}
        >
          {isSaving ? "Saving..." : "Save Changes"}
        </Button>
      </Box>
    </Grid>
  );
};

export default TemplateFormActions;
